import React, { useState, useEffect } from "react";

const ExploreExpComingSoon = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const targetDate = new Date("2024-12-31T00:00:00"); // Set your target date here

    const intervalId = setInterval(() => {
      const now = new Date();
      const difference = targetDate.getTime() - now.getTime();

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      } else {
        clearInterval(intervalId);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div
      className="h-full flex items-center justify-center pr-20 bg-gradient-to-r from-blue-100 to-indigo-200 rounded-xl"
      style={{ height: "calc(100vh - 130px)" }}
    >
      <div className="text-center text-white">
        <h1 className="text-5xl font-extrabold mb-6 text-indigo-800">
          Coming Soon
        </h1>
        <p className="text-xl mb-4 text-indigo-700 font-light">
          Get ready to share your favourite experiences with the Waytora
          community!
        </p>

        {/* <button className="mt-2 px-6 py-2 bg-white text-blue-600 rounded-full font-semibold hover:bg-stone-50 transition duration-300">
          Notify Me
        </button> */}
      </div>
    </div>
  );
};

export default ExploreExpComingSoon;
